import { useEffect, useState } from 'react';
import axios from 'axios';

// URL base from environment variables or fallback
const LIVE_URL = process.env.REACT_APP_LIVES_SERVER_URL || 'https://s1vzh3gy9i5nqs-8080.proxy.runpod.net';

export function useLiveInfo(liveId, state) {
  const [info, setInfo] = useState(null);
  const [loadingInfo, setLoadingInfo] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (liveId) {
      setLoadingInfo(true);
      const infoEndpoint = `${LIVE_URL}app/${state}/live/info/${liveId}`;
      const plainAxios = axios.create({});

      plainAxios
        .get(infoEndpoint)
        .then((res) => {
          setInfo(res.data.data);
          setLoadingInfo(false);
        })
        .catch((err) => {
          console.error('Error fetching live info:', err);
          setError(err);
          setLoadingInfo(false);
        });
    }
  }, [liveId, state]);

  return { info, loadingInfo, error };
}
